import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { bankSubmit } from "../../api";
import { swlAlert } from "../../../component";

/**
 * AddBankDetail1 component displays entered and bank-verified details for confirmation.
 * Handles submission of bank KYC data and navigation.
 */
const AddBankDetail1 = ({ login = null }) => {
  const [disbale, setDeisbale] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useParams();
  const bankdetails = location.state?.bankdetails || {};
  const enteredValue = location.state?.enteredValue || {};
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  function formatKey(key) {
    // Split the key by underscores, capitalize each part, and join with spaces
    return key
      .replace(/nameAtBank/g, "Name at Bank")
      .replace(/bankName/g, "Bank Name")
      .replace(/refId/g, "Ref Id")
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const bankKycSubmit = () => {
    setDeisbale(true)
    let data = {
      'name_at_bank': enteredValue.name,
      'account_number': enteredValue.account_number,
      're_enter_account_number': enteredValue.re_enter_account_number,
      'ifsc_code': enteredValue.ifsc_code,
      'iirpl_sap_code': userId,
      'apiresponse': bankdetails
    }
    bankSubmit(data)
      .then((d) => {
        if (Number(d?.data.code) === 0) {
          swlAlert(d.data)
        } else {
          navigate(`/${redirectUrl}/bankdetails-added/${userId}`);
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          alert(error.response.message)
        } else {
          // Handle other errors
          console.error("Error:", error);
        }
      });
  }
  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-check.png")}
              />
              <h6 className="mt-5">Bank Details are valid</h6>
            </div>

            <div className="px-2">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <div className="d-flex invalid_bankdata mb-5">
                <div className="invaild_data">
                  <label>Name at Bank</label>
                  <p>{enteredValue.name}</p>
                </div>

                <div className="invaild_data">
                  <label>Account Number</label>
                  <p>{enteredValue.account_number}</p>
                </div>

                <div className="invaild_data">
                  <label>IFSC Code</label>
                  <p>{enteredValue.ifsc_code}</p>
                </div>
              </div>
            </div>

            <div className="card_data bank_invliddata">
              <h6>Details As Per The Bank Details</h6>
              <ul className="details_card d-flex flex-wrap">
                {Object.entries(bankdetails).map(([key, value]) => (
                  <li key={key}>
                    <label>{formatKey(key)}:</label> <p>{value}</p>
                  </li>
                ))}
              </ul>
            </div>


            <div className="mt-3 d-flex justify-content-between">
              <Link to={`/${redirectUrl}/addbank-account/${userId}`}>
                <button style={{ background: '#112845' }} className="btn  btn-lg w-150px text-white">Back</button>
              </Link>

              <button disabled={disbale} className="btn btn-danger btn-lg btn-hover-success w-150px text-white" onClick={() => bankKycSubmit()}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBankDetail1;
